<div class="tenant-access">
    @if (tags().length) {
        <app-tag-list [ngModel]="tags()" (removed)="onTagRemoved($event)" />
    }

    <tools-input
        class="search"
        prefix="search"
        placeholder="Search entity"
        [formControl]="searchControl"
    />

    @if (isLoading()) {
        <div class="state-card">
            <p class="state-text">Searching...</p>
        </div>
    } @else if (showNoResults()) {
        <div class="state-card">
            <p class="state-text">
                @if (searchTerm()) {
                    No results found for
                    <strong class="term">
                        <span class="value">{{ searchTerm() }}</span>
                    </strong>
                    <br />
                    Please check the spelling or try another search.
                } @else {
                    No tenants available.
                }
            </p>
        </div>
    } @else {
        <ul class="results" aria-label="Tenants">
            @for (tenant of pagedTenants(); track tenant.id) {
                <li>
                    <button
                        type="button"
                        class="row"
                        [disabled]="isLoading()"
                        (click)="addTenant(tenant)"
                    >
                        <img
                            class="logo"
                            [src]="
                                tenant.tenantLogoUrl ||
                                'assets/tenant-no-image.png'
                            "
                            [alt]="tenant.name"
                        />
                        <span class="name">{{ tenant.name }}</span>
                    </button>
                </li>
            }
        </ul>

        @if (this.filteredTenants().length > TENANT_PAGE_SIZE) {
            <tools-paginator
                class="pager"
                [variant]="paginatorVariant"
                [length]="filteredTenants().length"
                [pageSize]="pageSize"
                [pageIndex]="pageIndex()"
                [hidePageSize]="true"
                (page)="onPageChange($event)"
            />
        }
    }
</div>
